import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import "./toolbar.styles.scss";

interface IProps {
    sideDrawerHandler: (status: boolean) => void;
    menus: {
        link: string;
        logo: string;
        name: string;
    }[];
}

function Toolbar({ sideDrawerHandler, menus }: IProps) {
    const handleClick = () => {
        sideDrawerHandler(true);
    };
    const history = useHistory();
    return (
        <div className="toolbar">
            <div className="toolbar__hamburger cursor">
                <i
                    className="material-icons toolbar__hamburger__icon"
                    onClick={handleClick}
                >
                    menu
                </i>
            </div>
            <div className="toolbar__menu">
                {menus.map((menu, index) => {
              
                    return (
                        <NavLink
                            exact
                            to={menu.link}
                            activeClassName="active"
                            className={`toolbar__menu__link ${
                                history.location.pathname.includes(menu.link)
                                    ? "active"
                                    : ""
                            }`}
                            key={index}
                            onClick={() =>
                                sessionStorage.setItem("_i", index + "")
                            }
                        >
                            <div className="toolbar__menu__link__item cursor">
                                <i className="material-icons">{menu.logo}</i>
                                <span className="toolbar__menu__link__item__title">
                                    {menu.name}
                                </span>
                            </div>
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
}

export default Toolbar;
